import OrderEditViewStore from '@components/order/stores/OrderEditViewStore';
import UserAddressDialog from '@components/user-address/components/UserAddressDialog';
import UserAddressEditViewStore from '@components/user-address/stores/UserAddressEditViewStore';
import DirectionsWalkRoundedIcon from '@mui/icons-material/DirectionsWalkRounded';
import RestaurantMenuTwoToneIcon from '@mui/icons-material/RestaurantMenuTwoTone';
import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import AddressOptionListItem from './AddressOptionListItem';
import UserAddressOptionListItem from './UserAddressOptionListItem';
import ComingForOrderOptionListItem from './ComingForOrderOptionListItem';
import ServeInRestaurantOptionListItem from './ServeInRestaurantOptionListItem';

interface AddressOptionListProps {
    orderEditViewStore: OrderEditViewStore;
    userAddressEditViewStore: UserAddressEditViewStore;
}

const AddressOptionList: React.FC<AddressOptionListProps> = observer(({ orderEditViewStore, userAddressEditViewStore }) => {
    const { addressOption, setAddressOption, userAddress, isRestaurantDeliveryActive, isRestaurantDeliveryEnabled } = orderEditViewStore;
    const { setIsUserAddressDialogOpen } = userAddressEditViewStore;
    return (
        <>
            <Box display={"flex"} flexDirection={"column"} gap={1.5}>
                <Box
                    display={"grid"}
                    gap={1.5}
                // gridTemplateColumns={{ lg: "repeat(2, minmax(0, 1fr))" }}
                >
                    <ComingForOrderOptionListItem selectedValue={addressOption} setAddressOption={setAddressOption} />
                    <ServeInRestaurantOptionListItem selectedValue={addressOption} setAddressOption={setAddressOption} />
                </Box>

                {isRestaurantDeliveryEnabled && (
                    <>
                        <UserAddressOptionListItem
                            userAddress={userAddress}
                            onUserAddressEditClick={() => setIsUserAddressDialogOpen(true)}
                            value={"user-address"}
                            selectedValue={addressOption}
                            onClick={setAddressOption}
                            disabled={isRestaurantDeliveryActive === false}
                        />
                    </>
                )}
            </Box>
            <UserAddressDialog userAddressEditViewStore={userAddressEditViewStore} />
        </>
    )
})

export default AddressOptionList;